module.exports = __webpack_public_path__ + "static/hero-1c2a236e114abd8877e33aff0528e03a.jpg";